<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-block footer-contact">
        <p class="footer-contact-line">
          <span>Hotline/Kontakt und Einstellservice:</span>
          <a class="footer-link" href="tel:01805073100">01805 0731 00*</a>
        </p>
        <p class="footer-price-line">*Festnetzpreis 14 ct/min; Mobilfunkpreise maximal 42 ct/min</p>
      </div>

      <div class="footer-block footer-center">
        <p v-if="admin" @click="PopInstructions"><a class="footer-link" href="#">Anleitung</a></p>
        <p v-if="viewer && !admin" @click="PopInstructions"><a class="footer-link" href="#">Anleitung</a></p>
        <p v-if="!admin && !viewer" @click="PopInstructions"><a class="footer-link" href="#">Anleitung</a></p>
        <p><a class="footer-link" target="_pk" href="https://www.priokom.de">www.priokom.de</a></p>
      </div>

      <div class="footer-block footer-meta">
        <p @click="PopDatenschutz"><a class="footer-link" href="#">Datenschutz</a></p>
        <p @click="PopImpressum"><a class="footer-link" href="#">Impressum</a></p>
        <p><a class="footer-link" target="_si" href="ofl.txt">SIL Info</a></p>
      </div>
    </div>

    <Modal v-model:visible="datenschutz" :okButton="safeButton" :title="titled" :width="widthd">
      <div>
        <TheDataPrivacy />
      </div>
    </Modal>
    <Modal v-model:visible="impressum" :okButton="safeButton" :cancelButton="cancelButton" :title="title" :width="width">
      <div><TheImpressum /></div>
    </Modal>
    <Modal v-model:visible="instructions" :okButton="safeButton" :cancelButton="cancelButton" :title="title" :width="width">
      <div><TheInstructions /></div>
    </Modal>
  </footer>
</template>

<script setup>
import VueJwtDecode from "vue-jwt-decode";
import { ref } from "vue";
import { Modal } from "usemodal-vue3";
import { IsAdmin, IsViewer } from "@/store/functions/rights";
import { computed } from "vue";
import { useStore } from "vuex";

let userRights = ref();
const store = useStore();
const loggedIn = computed(() => {
  return store.getters["auth/loggedIn"];
});

if (loggedIn.value) {
  const tokendecoded = VueJwtDecode.decode(
    JSON.parse(localStorage.getItem("user")).access_token
  );
  userRights = tokendecoded.rights;
}

const admin = IsAdmin(userRights);
const viewer = IsViewer(userRights);
const safeButton = { text: "Ok" };
const cancelButton = { text: "Abbrechen" };
const impressum = ref(false);
const instructions = ref(false);
const width = "90%";
const title = "";

function PopImpressum() {
  impressum.value = true;
}

function PopInstructions() {
  instructions.value = true;
}

const datenschutz = ref(false);
const widthd = "90%";
const titled = "Datenschutz";

function PopDatenschutz() {
  datenschutz.value = true;
}
</script>

<style scoped>
* {
  z-index: 99;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #4b4b4b;
  color: #f2f2f2;
}

.footer-content {
  max-width: 1360px;
  margin: 0 auto;
  padding: 12px 40px;
  display: grid;
  grid-template-columns: 50% 25% 25%;
  gap: 24px;
  align-items: center;
}

.footer-block {
  font-size: 0.875rem;
  line-height: 1.2;
}

.footer-block p {
  margin: 0;
}

.footer-block p + p {
  margin-top: 2px;
}

.footer-center,
.footer-meta {
  justify-self: start;
}

.footer-contact {
  max-width: 560px;
}

.footer-contact-line {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}

.footer-price-line {
  white-space: nowrap;
}

.footer-link {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.footer-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

@media (max-width: 1023px) {
  .footer-content {
    max-width: 360px;
    padding: 14px 20px;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "contact contact"
      "center meta";
    gap: 10px;
    text-align: left;
  }

  .footer-block {
    font-size: 0.78rem;
    line-height: 1.2;
  }

  .footer-contact {
    max-width: 100%;
    grid-area: contact;
    text-align: center;
  }

  .footer-contact-line {
    display: block;
  }

  .footer-contact-line .footer-link {
    display: block;
    margin-top: 2px;
  }

  .footer-price-line {
    white-space: normal;
  }

  .footer-block p + p {
    margin-top: 2px;
  }

  .footer-center {
    grid-area: center;
    justify-self: start;
    text-align: left;
  }

  .footer-meta {
    grid-area: meta;
    justify-self: end;
    text-align: left;
  }
}

@media (max-width: 480px) {
  .footer-content {
    max-width: 320px;
    padding: 12px 16px;
    gap: 8px;
  }

  .footer-block {
    font-size: 0.7rem;
    line-height: 1.15;
  }
}
</style>
